import config from 'react-global-configuration';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const SENTRY_DSN = 'https://ca945544808a4b978b4bcbd4606a4368@sentry.uncinc.nl/38';

export const DEFAULT_LANGUAGE = 'nl';
export const SITE_NAME = 'Werken bij HVC';
export const APP_ROOT_ELEMENT_ID = 'root';
export const MULTILINGUAL = false;

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export let API_URL = process.env.REACT_APP_API_URL || "/api";

export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';

// If we provide the API URL in the DOM, use that instead.
if (IS_CLIENT && document.getElementById(APP_ROOT_ELEMENT_ID).dataset.apiUrl) {
  API_URL = document.getElementById(APP_ROOT_ELEMENT_ID).dataset.apiUrl;
}

export let APP_OPTIONS = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: 'production',
    cesTargetNid: 10,
    searchkitIndexVacancies: 'elasticsearch_index_werkenbij_vacancy_index',
  },
};

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;
export const SCREEN_HUGE = 2000;

// Use config to share static configuration between components and packages.
config.set({
  SITE_NAME: SITE_NAME,
  MULTILINGUAL: false,
  DEFAULT_LANGUAGE: DEFAULT_LANGUAGE,
  API_URL: API_URL,
}, {
  // Set freeze to false to allow overwriting the configs based on the
  // options passed to window.reactFrontend
  freeze: false
});

// Image illustration types.
export const IMAGE_ILLUSTRATION_TYPE_LOTTIE = 'lottie';
export const IMAGE_ILLUSTRATION_TYPE_DOODLE_CORNERS = 'doodle_corners';
export const IMAGE_ILLUSTRATION_TYPE_ICON = 'icon';

export const routes = {
  applicationSent: '/vacatures/sollicitatie-verzonden',
  jobApplicationForm: '/vacatures/:vacancy/solliciteren',
};

export function saveConstants(options) {
  APP_OPTIONS = {
    ...APP_OPTIONS,
    parameters: {
      ...APP_OPTIONS.parameters,
      ...options.parameters,
    }
  };

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search';
  }

  if (APP_ENV === 'ci') {
    // Use proxy in ci to prevent CORS issues.
    API_URL = 'http://apache.docker/api';
    SEARCHKIT_HOST_URL = 'http://apache.docker/api/api-proxy/elasticsearch-proxy?_api_proxy_uri=';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'PAGE_TRANSITION_SPEED': 100,
  });
}

export const queryParamMappings = {
  'field_department_target_id': 'department',
  'field_address_target_id': 'area',
};

export const JOB_APPLICATION_URL = '/api-proxy/jobylon-proxy?_api_proxy_uri=/applications/';

export const OPEN_VACANCY_URL = '/vacatures/open-sollicitatie';

export const VACANCY_OVERVIEW_URL = '/vacatures';

export const HVC_GROEP_URL = 'https://www.hvcgroep.nl/';

export const SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/hvcgroep/';
export const SOCIAL_LINKEDIN_URL = 'https://nl.linkedin.com/company/hvc';
export const SOCIAL_X_URL = 'https://x.com/hvcgroep';
export const SOCIAL_INSTAGRAM_URL = 'https://www.instagram.com/hvcgroep/';
